export default __webpack_public_path__ + "static/media/Shot_34.0000.ab49a345.png";